import { r as s, j as n, R as A, I as E, H as k, T as N, C as j, c as w, a } from "./giftory-react-vendor.js";
/* empty css                         */
import { L as c } from "./giftory-utils.js";
const h = s.createContext({
  size: "desktop"
}), y = s.forwardRef(({ className: i, size: e = "desktop", ...t }, r) => {
  const o = s.useMemo(() => ({ size: e }), [e]);
  return /* @__PURE__ */ n.jsx(h.Provider, { value: o, children: /* @__PURE__ */ n.jsx(
    A,
    {
      ref: r,
      className: c("gf-w-full", i),
      "data-testid": "gf-accordion",
      ...t
    }
  ) });
});
y.displayName = "Accordion";
const u = s.forwardRef(({ className: i, ...e }, t) => /* @__PURE__ */ n.jsx(
  E,
  {
    ref: t,
    className: c(
      "group accordion-item gf-border-b gf-border-neutrals-40 gf-bg-transparent",
      "data-[disabled]:gf-opacity-50 data-[disabled]:gf-cursor-not-allowed",
      i
    ),
    "data-testid": "gf-accordion-item",
    ...e
  }
));
u.displayName = "AccordionItem";
const m = s.forwardRef(({ className: i, children: e, showChevron: t = !0, chevronIcon: r, ...o }, l) => {
  const { size: d } = s.useContext(h);
  return /* @__PURE__ */ n.jsx(k, { className: "gf-flex", "data-testid": "gf-accordion-header", children: /* @__PURE__ */ n.jsxs(
    N,
    {
      ref: l,
      className: c(
        "gf-flex gf-flex-1 gf-items-center gf-justify-between gf-px-0",
        "gf-font-bold gf-text-primary-blackout",
        "gf-transition-all gf-duration-200",
        "hover:gf-underline hover:gf-decoration-solid",
        "focus-visible:gf-outline-none focus-visible:gf-ring-2 focus-visible:gf-ring-ring focus-visible:gf-ring-offset-2",
        "disabled:gf-pointer-events-none disabled:gf-opacity-50",
        "[&[data-state=open]_.gf-vertical-line]:gf-opacity-0",
        // Icon state management
        "[&[data-state=open]_.gf-accordion-plus]:gf-opacity-0",
        "[&[data-state=open]_.gf-accordion-minus]:gf-opacity-100",
        // Size-specific styles
        d === "desktop" ? "gf-py-6 gf-text-lg gf-leading-6 gf-gap-6" : "gf-py-4 gf-text-sm gf-leading-5 gf-gap-5",
        i
      ),
      "data-testid": "gf-accordion-trigger",
      ...o,
      children: [
        /* @__PURE__ */ n.jsx("div", { className: "gf-flex-1 gf-text-left", "data-testid": "gf-accordion-trigger-text", children: e }),
        t && /* @__PURE__ */ n.jsx(
          "div",
          {
            className: "gf-flex gf-items-center gf-shrink-0",
            "data-testid": "gf-accordion-chevron-container",
            children: r || /* @__PURE__ */ n.jsx(
              "div",
              {
                className: c(
                  "gf-bg-neutrals-40 hover:gf-bg-neutrals-60 gf-rounded-full gf-flex gf-items-center gf-justify-center",
                  d === "desktop" ? "gf-p-3" : "gf-p-2.5"
                ),
                "data-testid": "gf-accordion-chevron-button",
                children: /* @__PURE__ */ n.jsxs(
                  "svg",
                  {
                    className: c(
                      "gf-accordion-icon gf-transition-all gf-duration-200",
                      d === "desktop" ? "gf-w-3.5 gf-h-3.5" : "gf-w-3 gf-h-3"
                    ),
                    viewBox: "0 0 14 14",
                    fill: "none",
                    "data-testid": "gf-accordion-icon",
                    children: [
                      /* @__PURE__ */ n.jsx(
                        "path",
                        {
                          className: "gf-accordion-plus gf-transition-opacity gf-duration-200",
                          d: "M7.89727 2.06406C7.89727 1.56767 7.49623 1.16663 6.99984 1.16663C6.50344 1.16663 6.1024 1.56767 6.1024 2.06406V6.10252H2.06394C1.56755 6.10252 1.1665 6.50356 1.1665 6.99996C1.1665 7.49635 1.56755 7.89739 2.06394 7.89739H6.1024V11.9359C6.1024 12.4323 6.50344 12.8333 6.99984 12.8333C7.49623 12.8333 7.89727 12.4323 7.89727 11.9359V7.89739H11.9357C12.4321 7.89739 12.8332 7.49635 12.8332 6.99996C12.8332 6.50356 12.4321 6.10252 11.9357 6.10252H7.89727V2.06406Z",
                          fill: "#585468",
                          "data-testid": "gf-accordion-plus-icon"
                        }
                      ),
                      /* @__PURE__ */ n.jsx(
                        "path",
                        {
                          className: "gf-accordion-minus gf-transition-opacity gf-duration-200 gf-opacity-0",
                          d: "M12.8332 6.99552C12.8332 7.49191 12.4321 7.89296 11.9357 7.89296H2.06394C1.56755 7.89296 1.1665 7.49191 1.1665 6.99552C1.1665 6.49913 1.56755 6.09808 2.06394 6.09808H11.9357C12.4321 6.09808 12.8332 6.49913 12.8332 6.99552Z",
                          fill: "#585468",
                          "data-testid": "gf-accordion-minus-icon"
                        }
                      )
                    ]
                  }
                )
              }
            )
          }
        )
      ]
    }
  ) });
});
m.displayName = "AccordionTrigger";
const p = s.forwardRef(({ className: i, children: e, ...t }, r) => {
  const { size: o } = s.useContext(h);
  return /* @__PURE__ */ n.jsx(
    j,
    {
      ref: r,
      className: c(
        "gf-overflow-hidden gf-text-neutrals-100 gf-font-medium",
        "data-[state=closed]:gf-animate-accordion-up data-[state=open]:gf-animate-accordion-down",
        "[&_a]:gf-text-[#4e9fac] [&_a]:gf-font-bold [&_a]:gf-no-underline hover:[&_a]:gf-underline",
        // Size-specific styles
        o === "desktop" ? "gf-text-base gf-leading-6" : "gf-text-sm gf-leading-5",
        i
      ),
      "data-testid": "gf-accordion-content",
      ...t,
      children: /* @__PURE__ */ n.jsx("div", { className: c("gf-px-0 gf-pt-0 gf-pb-6"), "data-testid": "gf-accordion-content-inner", children: e })
    }
  );
});
p.displayName = "AccordionContent";
class H extends HTMLElement {
  constructor() {
    super(...arguments), this.root = null, this.container = null;
  }
  static get observedAttributes() {
    return [
      "type",
      "size",
      "collapsible",
      "default-value",
      "value",
      "disabled",
      "orientation",
      "trigger",
      "class-name",
      "id",
      "data-enhanced"
    ];
  }
  connectedCallback() {
    this.container = this, this.root = w(this.container), this.render(), this.setupEventListeners(), this.setAttribute("data-enhanced", "true");
  }
  disconnectedCallback() {
    this.root && (this.root.unmount(), this.root = null);
  }
  attributeChangedCallback(e, t, r) {
    t !== r && this.render();
  }
  setupEventListeners() {
    this.addEventListener("click", (e) => {
      this.dispatchEvent(
        new CustomEvent("giftory-accordion-click", {
          detail: {
            originalEvent: e,
            props: this.getPropsFromAttributes()
          },
          bubbles: !0,
          cancelable: !0
        })
      );
    });
  }
  render() {
    if (!this.root) return;
    const e = this.getPropsFromAttributes(), t = this.getChildrenFromSlots(), r = {
      type: e.type || "single",
      ...e,
      children: t
    };
    this.root.render(a.createElement(y, r));
  }
  getPropsFromAttributes() {
    const e = {};
    for (const t of this.attributes) {
      const r = this.attributeToPropName(t.name);
      e[r] = this.convertAttributeValue(t.value, r);
    }
    return e.type || (e.type = "single"), e;
  }
  getChildrenFromSlots() {
    var r;
    const e = (r = this.innerHTML) == null ? void 0 : r.trim();
    if (!e) return null;
    const t = this.querySelectorAll("giftory-accordion-item");
    if (t.length > 0)
      return Array.from(t).map((o, l) => {
        var b, x;
        const d = o.getAttribute("value") || `item-${l + 1}`, f = o.querySelector("giftory-accordion-trigger"), g = o.querySelector("giftory-accordion-content"), v = ((b = f == null ? void 0 : f.textContent) == null ? void 0 : b.trim()) || "Click to expand", C = ((x = g == null ? void 0 : g.innerHTML) == null ? void 0 : x.trim()) || "";
        return a.createElement(
          u,
          {
            key: d,
            value: d
          },
          a.createElement(m, {}, v),
          a.createElement(
            p,
            {},
            a.createElement("div", { dangerouslySetInnerHTML: { __html: C } })
          )
        );
      });
    {
      const o = this.getAttribute("trigger") || "Click to expand";
      return a.createElement(
        u,
        {
          key: "item-1",
          value: "item-1"
        },
        a.createElement(m, {}, o),
        a.createElement(
          p,
          {},
          a.createElement("div", { dangerouslySetInnerHTML: { __html: e } })
        )
      );
    }
  }
  attributeToPropName(e) {
    return e.replace(/-([a-z])/g, (t, r) => r.toUpperCase());
  }
  convertAttributeValue(e, t) {
    if (e === "true") return !0;
    if (e === "false") return !1;
    if (e === "null" || e === "undefined") return null;
    switch (t) {
      case "disabled":
      case "loading":
      case "required":
      case "readonly":
      case "checked":
      case "multiple":
      case "closable":
      case "iconOnly":
      case "fullWidth":
      case "collapsible":
        return e !== "false";
      case "maxlength":
      case "minlength":
      case "tabindex":
      case "duration":
        return e ? parseInt(e, 10) : void 0;
      case "size":
        return e === "mobile" ? "mobile" : "desktop";
      case "variant":
      case "type":
      case "placeholder":
      case "value":
      case "name":
      case "placement":
      case "trigger":
      case "position":
      case "emptyMessage":
        return e;
      default:
        return e;
    }
  }
}
typeof window != "undefined" && !customElements.get("giftory-accordion") && customElements.define("giftory-accordion", H);
export {
  H as AccordionWC
};
